export default __webpack_public_path__ + "static/5-f27d2fc25a81dbf6e87a66867080e458.png";